import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { plants } from '../services/api';
import GardenModal from './GardenModal';
import { useIsMobile } from '../hooks/useIsMobile';
import './EditPlant.css';

function EditPlant() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({ isOpen: false });
  const isMobile = useIsMobile();
  const [formData, setFormData] = useState({
    commonName: '',
    scientificName: '',
    plantType: '',
    datePlanted: '',
    notes: ''
  });

  useEffect(() => {
    loadPlant();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const loadPlant = async () => {
    try {
      const response = await plants.getOne(id);
      const plant = response.data.plant;
      setFormData({
        commonName: plant.common_name || '',
        scientificName: plant.scientific_name || '',
        plantType: plant.plant_type || '',
        datePlanted: plant.date_planted ? plant.date_planted.split('T')[0] : '',
        notes: plant.notes || ''
      });
      setLoading(false);
    } catch (error) {
      console.error('EditPlant: loadPlant failed:', error);
      setModal({
        isOpen: true, type: 'alert', title: 'Error',
        message: 'Failed to load plant',
        onConfirm: () => { setModal({ isOpen: false }); navigate('/plants'); }
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await plants.update(id, {
        commonName: formData.commonName,
        scientificName: formData.scientificName,
        plantType: formData.plantType,
        datePlanted: formData.datePlanted || null,
        notes: formData.notes
      });
      setModal({
        isOpen: true, type: 'alert', title: 'Success',
        message: 'Plant updated successfully!',
        onConfirm: () => { setModal({ isOpen: false }); navigate(`/plants/${id}`); }
      });
    } catch (error) {
      console.error('EditPlant: update failed:', error);
      setModal({
        isOpen: true, type: 'alert', title: 'Error',
        message: 'Failed to update plant',
        onConfirm: () => setModal({ isOpen: false })
      });
    }
  };

  if (loading) return <div className="edit-plant-loading">Loading...</div>;

  return (
    <div className={`edit-plant-container${isMobile ? ' edit-plant-container--mobile' : ''}`}>
      <GardenModal isOpen={modal.isOpen} type={modal.type} title={modal.title} message={modal.message} onConfirm={modal.onConfirm} onCancel={() => setModal({ isOpen: false })} />
      <h2>Edit Plant</h2>

      <form onSubmit={handleSubmit} className="edit-plant-form">

        <div className="edit-plant-field">
          <label className="edit-plant-label">Plant Name *</label>
          <input
            type="text"
            value={formData.commonName}
            onChange={(e) => setFormData({...formData, commonName: e.target.value})}
            required
            className="edit-plant-input"
          />
        </div>

        <div className="edit-plant-field">
          <label className="edit-plant-label">Scientific Name</label>
          <input
            type="text"
            value={formData.scientificName}
            onChange={(e) => setFormData({...formData, scientificName: e.target.value})}
            className="edit-plant-input"
          />
        </div>

        <div className="edit-plant-field">
          <label className="edit-plant-label">Plant Type</label>
          <select
            value={formData.plantType}
            onChange={(e) => setFormData({...formData, plantType: e.target.value})}
            className="edit-plant-input"
          >
            <option value="">Select type...</option>
            <option value="flower">Flower</option>
            <option value="fruit">Fruit</option>
            <option value="herb">Herb</option>
            <option value="shrub">Shrub</option>
            <option value="tree">Tree</option>
            <option value="vegetable">Vegetable</option>
            <option value="vine">Vine</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div className="edit-plant-field">
          <label className="edit-plant-label">Date Planted</label>
          <input
            type="date"
            value={formData.datePlanted}
            onChange={(e) => setFormData({...formData, datePlanted: e.target.value})}
            className="edit-plant-input"
          />
        </div>

        <div className="edit-plant-field edit-plant-field--last">
          <label className="edit-plant-label">Notes</label>
          <textarea
            value={formData.notes}
            onChange={(e) => setFormData({...formData, notes: e.target.value})}
            rows="4"
            className="edit-plant-textarea"
          />
        </div>

        <div className="edit-plant-actions">
          <button type="submit" className="edit-plant-btn-save">
            Save Changes
          </button>
          <button type="button" onClick={() => navigate(`/plants/${id}`)} className="edit-plant-btn-cancel">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditPlant;
